

































import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { ChatParticipant, Conversation } from '../types';
import { ConversationType } from '../types';
import { ChatHelper } from '../helpers';
import AddParticipantsInput from './AddParticipantsInput.vue';
import ChatListAvatars from './ChatListAvatars.vue';

export default defineComponent({
  name: 'NewChatHeader',
  components: {
    AddParticipantsInput,
    ChatListAvatars,
  },
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: undefined,
    },
    creatingNewConversation: {
      type: Boolean,
    },
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
    recipients: {
      type: Array as PropType<Recipient[]>,
      default: () => [],
    },
    owner: {
      type: Object as PropType<User>,
      default: null,
    },
    recipientId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const title = computed(() =>
      props.conversation.type === ConversationType.General
        ? t('dsr_chat_all_participants')
        : props.conversation.title || getParticipantNames()
    );

    const getParticipantNames = () =>
      ChatHelper.getParticipantNames(props.participants, props.conversation.participants);

    const getAllRecipientNames = () => {
      let names = props.recipients
        .filter(recipient => recipient.id !== props.recipientId)
        .map(recipient => recipient.fullName);

      if (props.owner) {
        names.push(props.owner.fullName);
      }
      return `${t('you')}, ${names.join(', ')}`;
    };

    return {
      getParticipantNames,
      getAllRecipientNames,
      title,
      ConversationType,
    };
  },
});
